export interface IFilterMarquesSearch {
    IdSociete?: number;
    IdActeurJuridique?: number;
    IdMarque?: number;
    SearchLibelle?:string;
    IsDescending?: boolean;
    SortField?: string;
    Limit?: number;
  }


  export const getDefaultFilterMarques = (): IFilterMarquesSearch => ({
    IdSociete:0,
    IdActeurJuridique: undefined,
    IdMarque: undefined,
    SearchLibelle: "",
  });
  
  export const filterToQuery = (filter: IFilterMarquesSearch): IFilterMarquesSearch => {
    const dto: IFilterMarquesSearch = {};
 
    if (filter?.IdSociete !== undefined ) {
      dto.IdSociete = filter.IdSociete;
    } 

    if (filter?.IdActeurJuridique !== undefined ) {
      dto.IdActeurJuridique = filter.IdActeurJuridique;
    } 

    if (filter?.IdMarque !== undefined ) {
      dto.IdMarque = filter.IdMarque;
    } 

    if (filter?.SearchLibelle !== "" ) {
      dto.SearchLibelle = filter.SearchLibelle;
    } 
 
    localStorage.setItem("IFilterMarquesSearch", JSON.stringify(dto));
  
    return dto;
  };
  
  export const dtoToFilter = (dto: IFilterMarquesSearch): IFilterMarquesSearch => {
  
    return {
      IdSociete: dto.IdSociete !== undefined ? dto.IdSociete : 0,
      IdActeurJuridique: dto.IdActeurJuridique !== undefined ? dto.IdActeurJuridique : 0,
      IdMarque: dto.IdMarque !== undefined ? dto.IdMarque : 0,
      SearchLibelle: dto.SearchLibelle !== undefined ? dto.SearchLibelle : "",
    };
  };
 